import { render } from "./QueriesCommunity.vue?vue&type=template&id=2684c8e4&ts=true"
import script from "./QueriesCommunity.vue?vue&type=script&lang=ts"
export * from "./QueriesCommunity.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__